import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { ErrorMessageModule } from '../error-message/error-message.module';
import { TooltipMessageModule } from '../tooltip-message/tooltip-message.module';
import { NgSelectMultiple } from '../utils/models/NgSelectMultiple';
import { NgSelectMultipleComponent } from './ng-select-multiple.component';
import { NgSelectMultipleService } from './ng-select-multiple.service';
import { MatTooltipModule } from '@angular/material/tooltip';



@NgModule({
  declarations: [NgSelectMultipleComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ErrorMessageModule,
    TooltipMessageModule,
    NgSelectModule,
    MatCheckboxModule,
    MatTooltipModule
  ],
  exports: [NgSelectMultipleComponent]
})
export class NgSelectMultipleModule {
  static forRoot(ngSelectMultiple: NgSelectMultiple = new NgSelectMultiple()): ModuleWithProviders<NgSelectMultipleModule> {
    return {
      ngModule: NgSelectMultipleModule,
      providers: [
        { provide: 'NG_SELECT_MULTIPLE_SHOWLIMIT', useValue: ngSelectMultiple.showlimit },
        { provide: 'NG_SELECT_MULTIPLE_HEADER', useValue: ngSelectMultiple.Header },
        { provide: 'NG_SELECT_MULTIPLE_FOOTER', useValue: ngSelectMultiple.Footer },
        { provide: 'NG_SELECT_MULTIPLE_VALIDATOR_MESSAGE', useValue: ngSelectMultiple.validatorMessage },
        { provide: 'NG_SELECT_MULTIPLE_TOOLTIP_MESSAGE', useValue: ngSelectMultiple.tooltipMessage },
        { provide: 'NG_SELECT_MULTIPLE_OPEN_WHEN_FOCUS', useValue: ngSelectMultiple.openWhenFocus },
        { provide: 'NG_SELECT_MULTIPLE_SUBMITTED', useValue: ngSelectMultiple.submitted },
        { provide: 'NG_SELECT_MULTIPLE_VALIDATOR_ALERT', useValue: ngSelectMultiple.validatorAlert },
        { provide: 'NG_SELECT_MULTIPLE_APPEND_TO', useValue: ngSelectMultiple.appendTo },
        { provide: 'NG_SELECT_MULTIPLE_LOADING_TEXT', useValue: ngSelectMultiple.loadingText },
        { provide: 'NG_SELECT_MULTIPLE_MARK_FIRST', useValue: ngSelectMultiple.markFirst },
        NgSelectMultipleService
      ]
    }
  }
}
